import '../styles/index.css';

import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import AppShell from './AppShell';
import { registerAppServiceWorker } from '../application/pwa/appUpdate';
import { rememberEntryRoute } from '../application/pwa/entryRoute';
import { startInstallPromptWatch } from '../application/pwa/installPrompt';
import { startViewportSync } from '../application/pwa/viewportSync';

// Before anything can navigate. Which screen this app STARTED on is the one
// signal that separates somebody who followed a shared link to a car from
// somebody who walked to the same car from the front door, and it stops being
// knowable the moment the router runs.
rememberEntryRoute(window.location.pathname);

const root = createRoot(document.getElementById('app'));

root.render(
    <BrowserRouter>
        <AppShell />
    </BrowserRouter>,
);

// The tab bar has to sit on the REAL bottom edge on iOS, where 100vh is not the
// visible height; this keeps `--app-viewport-height` in step with the visual
// viewport so `foundations.css` can size the shell against it.
startViewportSync();
registerAppServiceWorker();
// Bound before React mounts, because Chromium fires `beforeinstallprompt` once
// and early: a listener bound from a component would miss it, and there is no
// way to ask for the event again.
startInstallPromptWatch();
